<template>
  <p
    class="text-sm"
    :class="[product.availabilities.estimated_shipping_time <= 3 ? 'text-green-600' : 'text-gray-500']"
  >
    {{ deliveryRange(estimatedDays) }}
  </p>
</template>

<script setup>
import { computed } from 'vue';
import useProductEstimatedTime from '../../../composables/useEstimatedTime';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  shop: {
    type: Object,
    required: true,
  },
});

const estimatedDays = computed(() => {
  const estimatedDeliveryDays = +(props.shop.settings.find((setting) => setting.code === 'estimated_delivery_days')?.option.value || 0);
  const estimatedShippingDays = +(props.shop.settings.find((setting) => setting.code === 'estimated_shipping_days')?.option.value || 0);
  const productShippingTime = +(props.product.availabilities.estimated_shipping_time || 0);
  const productShippingDays = estimatedShippingDays > productShippingTime ? estimatedShippingDays : productShippingTime;

  return props.shop.settings.find((setting) => setting.code === 'estimated_type')?.option.value === 'livraison'
    ? +estimatedDeliveryDays + (productShippingTime - 2)
    : productShippingDays;
});

const { deliveryRange } = useProductEstimatedTime();
</script>
